// MAPA[path, size, title] and the chapter-map div it stands for: Markdown::Notation.map, argument for argument.
const ENTITY_AMPERSAND = /&(?!(?:[a-z][a-z0-9]{1,30}|#\d{1,7}|#x[0-9a-f]{1,6});)/gi;
const escapeAttribute = (value: string) => value.replace(ENTITY_AMPERSAND, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const MAP_DIV = /^<div\b([^>]*)>\s*<img\b([^>]*)>\s*<\/div>$/;
const attributes = (source: string) => Object.fromEntries([...source.matchAll(/([\w-]+)="([^"]*)"/g)].map((m) => [m[1], m[2]]));

// An element's tag, attributes and children, ignoring the white space between tags and attributes.
function structure(node: Element): unknown {
	const children = Array.from(node.childNodes).filter((child) => child.nodeType === 1 || child.textContent?.trim());
	return [
		node.tagName,
		Object.fromEntries(Array.from(node.attributes, (a) => [a.name, a.value]).sort()),
		children.map((child) => (child.nodeType === 1 ? structure(child as Element) : child.textContent)),
	];
}
const parse = (html: string) => new DOMParser().parseFromString(html, "text/html").body.firstElementChild;

export function expandMap(args: string): string | null {
	const first = /\s*,\s*/.exec(args);
	const second = first && /\s*,\s*/.exec(args.slice(first.index + first[0].length));
	if (!first || !second) return null;
	const rest = args.slice(first.index + first[0].length);
	const [path, size, title] = [args.slice(0, first.index), rest.slice(0, second.index), rest.slice(second.index + second[0].length)].map(escapeAttribute);
	const players = path.replace(/(\.\w+)$/, "-players$1");
	return `<div data-controller="chapter-map" data-chapter-map-button-class="mx-auto my-2 odo-button__primary">\n  <img title="${title}" alt="${title}" class="${size}" data-chapter-map-target="image" src="CHAPTER_ASSET_PATH[${path}]" data-player-version="CHAPTER_ASSET_PATH[${players}]">\n</div>`;
}

// The MAPA arguments for a chapter-map div, or null unless Ruby expands them back into the same div.
export function mapArgs(html: string): string | null {
	const m = MAP_DIV.exec(html.trim());
	if (!m) return null;
	const img = attributes(m[2]);
	const path = /^CHAPTER_ASSET_PATH\[([^\]]*)\]$/.exec(img.src ?? "");
	if (!path) return null;
	const args = `${path[1]}, ${img.class}, ${img.title}`;
	const expanded = /^[^\]\n]+$/.test(args) ? expandMap(args) : null;
	const [original, candidate] = [parse(html), expanded && parse(expanded)];
	return original && candidate && JSON.stringify(structure(original)) === JSON.stringify(structure(candidate)) ? args : null;
}
